import url1 from '../../assets/images/投诉请求.png';
import url2 from '../../assets/images/建议征集.png';
import url3 from '../../assets/images/信访查询.png';
import url4 from '../../assets/images/个人中心.png';
export const edipData = [
  {
    name: "投诉请求",
    type: "complaint",
    edited: true,
    title: "投诉须知",
    Confirmation:
      "我承诺提出的信访事项客观真实，并对所提供材料内容的真实性负责。",
    push: "/comiplat",
    url: url1 ,
  },
  {
    name: "建议征集",
    type: "proposal",
    edited: true,
    title: "建议须知",
    Confirmation:
      "我承诺提出的信访事项客观真实，并对所提供材料内容的真实性负责。",
    push: "/propscal",
    url: url2,
  },
  {
    name: "查询评价",
    type: "evaluate",
    edited: true,
    url: url3,
    push: "/queryCenter",
  },
  {
    name: "个人中心",
    type: "userInfo",
    edited: true,
    url: url4,
    push: "/persCenter",
  },
];
